<div
  class="chatbot-container position-fixed bottom-0 end-0 p-3"
  style="position: fixed; bottom: 2rem; right: 2rem; z-index: 1200"
>
  <!-- Chat Button (when closed) -->
  <button
    *ngIf="!isOpen"
    class="btn rounded-circle shadow-lg"
    (click)="openChat()"
    aria-label="Open chat support"
    style="
      width: 4rem;
      height: 4rem;
      background-color: #dbeafe !important;
      border-color: #dbeafe !important;
      color: #1e40af !important;
      animation: bounce 2s infinite;
    "
  >
    <i class="bi bi-headset fs-4"></i>
  </button>

  <!-- Chat Window -->
  <div
    *ngIf="isOpen"
    class="card shadow-lg border-0"
    [class.minimized]="isMinimized"
    style="
      width: 20rem;
      border: 1px solid rgba(30, 64, 175, 0.3) !important;
      transition: all 0.3s ease;
    "
    [ngStyle]="
      isMinimized ? { height: '4rem', overflow: 'hidden' } : { height: '24rem' }
    "
  >
    <!-- Chat Header -->
    <div
      class="p-3 d-flex align-items-center justify-content-between"
      style="
        background: linear-gradient(
          to right,
          var(--kemis-blue),
          var(--kemis-dark-blue)
        ) !important;
        color: white;
      "
    >
      <div class="d-flex align-items-center gap-2">
        <i class="bi bi-headset"></i>
        <span class="fw-semibold">KEMIS Support</span>
        <div
          class="rounded-circle"
          style="
            width: 0.5rem;
            height: 0.5rem;
            background-color: #198754;
            animation: pulse 2s infinite;
          "
        ></div>
      </div>
      <div class="d-flex gap-1">
        <button
          class="btn btn-sm text-white p-1"
          (click)="toggleMinimize()"
          aria-label="Minimize chat"
          style="width: 2rem; height: 2rem; border: none !important"
        >
          <i class="bi bi-dash"></i>
        </button>
        <button
          class="btn btn-sm text-white p-1"
          (click)="closeChat()"
          aria-label="Close chat"
          style="width: 2rem; height: 2rem; border: none !important"
        >
          <i class="bi bi-x"></i>
        </button>
      </div>
    </div>

    <!-- Chat Content -->
    <div *ngIf="!isMinimized" class="d-flex flex-column" style="height: 20rem">
      <!-- Messages -->
      <div class="flex-grow-1 overflow-auto p-3" style="scrollbar-width: thin">
        <div
          *ngFor="let message of messages"
          class="message mb-3"
          [ngStyle]="{
            display: 'flex',
            'justify-content':
              message.sender === 'user' ? 'flex-end' : 'flex-start'
          }"
        >
          <div
            class="p-3 rounded shadow-sm"
            [ngStyle]="
              message.sender === 'user'
                ? {
                    background: 'var(--kemis-blue)',
                    color: 'white',
                    'max-width': '75%'
                  }
                : {
                    background: 'white',
                    color: '#374151',
                    border: '1px solid #e5e7eb',
                    'max-width': '75%'
                  }
            "
          >
            <div class="mb-1">
              <i
                class="bi"
                [ngClass]="
                  message.sender === 'bot' ? 'bi-robot' : 'bi-person-circle'
                "
                style="font-size: 1rem"
              ></i>
            </div>
            <p class="small mb-0">{{ message.text }}</p>
          </div>
        </div>
      </div>

      <!-- Input Area -->
      <div class="p-3 border-top bg-light">
        <div class="input-group">
          <input
            type="text"
            class="form-control border-primary"
            [(ngModel)]="inputValue"
            (keypress)="onKeyPress($event)"
            placeholder="Type your message..."
            #messageInput
            style="box-shadow: 0 0 0 0.2rem rgba(30, 64, 175, 0.25) !important"
          />
          <button
            class="btn px-3"
            (click)="sendMessage()"
            aria-label="Send message"
            style="
              background-color: #dbeafe !important;
              border-color: #dbeafe !important;
              color: #1e40af !important;
            "
          >
            <i class="bi bi-send"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
